module.exports = __webpack_public_path__ + "static/img/3143_phase_function_Paper_Points.dfc321d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3143_phase_function_Paper_Points.png
// module id = LOgw
// module chunks = 0